import { useGoogleAnalytics } from '../hooks/use-google-analytics';

export function GoogleAnalyticsProvider({ children }: { children: React.ReactNode }) {
    useGoogleAnalytics();

    return children;
}
